import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-incomplete-profiles',
  templateUrl: './incomplete-profiles.component.html',
  styleUrls: ['./incomplete-profiles.component.css']
})
export class IncompleteProfilesComponent implements OnInit {

  incompleteProfilesReport=[];

  constructor(private masterDataService: MasterDataService) { }

  ngOnInit(): void {
    this.showExportToExcelButton
     this.getIncompleteProfilesDetails();
  }

  getIncompleteProfilesDetails() {
    this.masterDataService
        .getIncompleteProfilesReport()
        .subscribe((res:any) => {
          this.incompleteProfilesReport = res;
          if (res != null) {
            this.showExportToExcelButton = true;
          }
        });
  }

  showExportToExcelButton: boolean;
  onExportToExcelReport() {
    this.masterDataService.getIncompleteProfilesReportExcel().subscribe((resp: any) => {
      console.log('resp', resp);
      const blob = new Blob([resp]); // you can change the type
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "IncompleteProfilesReport.xlsx";
      link.click();
    });
  }

}
